export default {
  data() {
    return {
      tabList: [
        {
          id: 1,
          name: 'В чате звонка',
          content: {
            cardList: [
              {
                id: 1,
                title: 'Пригласите технического специалиста',
                description:
                  'прямо из\u00A0чата звонка по\u00A0кнопке «Поддержка» или\u00A0«Сообщить о\u00A0проблеме»',
                type: 'main',
              },
              {
                id: 2,
                title: 'от 15 минут',
                description: 'среднее время<br/>решения вопроса',
                type: 'white',
              },
              {
                id: 3,
                title: '3-5 минут',
                description: 'средняя скорость<br/>реакции',
                type: 'gradient',
              },
            ],
            image: 'call-chat',
          },
        },
        {
          id: 2,
          name: 'В личном кабинете',
          content: {
            cardList: [
              {
                id: 1,
                title: 'Напишите в\u00A0чат технической поддержки',
                description: 'в личном кабинете МТС\u00A0Линк',
                type: 'main',
              },
              {
                id: 2,
                title: 'от 15 минут',
                description: 'среднее время<br/>решения вопроса',
                type: 'white',
              },
              {
                id: 3,
                title: '5 минут',
                description: 'средняя скорость<br/>реакции',
                type: 'gradient',
              },
            ],
            image: 'personal-account',
          },
        },
        {
          id: 3,
          name: 'По телефону',
          content: {
            cardList: [
              {
                id: 1,
                title: 'Обратитесь в\u00A0поддержку по\u00A0телефону',
                description: `
                    <p>если звонить удобнее, чем\u00A0писать</p>
                    <a href="tel:+78005510669">8 (800) 551-06-69</a><br/>
                    <a href="tel:+74951470663">8 (495) 147-06-63</a>
                  `,
                type: 'main',
              },
              {
                id: 2,
                title: '5-8%',
                description:
                  'количество пропущенных<br/>звонков с последующим<br/>дозвоном',
                type: 'white',
              },
              {
                id: 3,
                title: '35 секунд',
                description: 'средняя скорость<br/>реакции',
                type: 'gradient',
              },
              {
                id: 4,
                title: '6 минут',
                description: 'среднее время<br/>решения вопроса',
                type: 'yellow',
              },
            ],
            image: 'phone',
          },
        },
      ],
    }
  },
}
